export const LOAN_CORP = {
    1: {
        en: 'Small Business',
        es: 'Pequeña empresa'
    },
    3: {
        en: 'Charter School Loans',
        es: 'Préstamos para escuelas charter'
    },
    99: {
        en: 'Partnership Microloan',
        es: 'Micropréstamo conjunto'
    },
    98: {
        en: 'Partnership Rural',
        es: 'Rural conjunto'
    },
    400: {
        en: 'Rural',
        es: 'Rural'
    },
    500: {
        en: 'Microloan',
        es: 'Micropréstamo'
    },
    600: {
        en: 'BIPOC Community Managed Loan Fund',
        es: 'Fondo de préstamos gestionado por la comunidad BIPOC'
    },
    601: {
        en: 'BIPOC Partnership Loan',
        es: 'Préstamo BIPOC conjunto'
    }
} as Record<string, { en: string; es: string }>;
